require('../../modules/es7.array.includes');
module.exports = require('../../modules/_core').Array.includes;



//////////////////
// WEBPACK FOOTER
// ./~/@babel/polyfill/~/core-js/fn/array/includes.js
// module id = o2V5
// module chunks = 0